import { httpClient } from '@/services/http/httpClient'

type RecuseIdeaSchema = {
  ideaId: string
  message: string
}

export async function recuseIdea({
  ideaId,
  message,
}: RecuseIdeaSchema): Promise<void> {
  await httpClient.put(`/ideas/ideas/${ideaId}/decline`, {
    comment: message,
  })
}
